var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pm-list-index" },
    [
      _c(
        "div",
        { staticClass: "filter" },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Filter Area",
              outlined: "",
              dense: "",
              items: Array.from(_setup.tableAreas.values())
            },
            model: {
              value: _setup.tableState.filter.area,
              callback: function($$v) {
                _vm.$set(_setup.tableState.filter, "area", $$v)
              },
              expression: "tableState.filter.area"
            }
          })
        ],
        1
      ),
      _c("v-simple-table", [
        !_setup.breakpoints.mobile
          ? _c("thead", [
              _c(
                "tr",
                _vm._l(_setup.headers, function(header) {
                  return _c("th", { key: header.value }, [
                    _vm._v(" " + _vm._s(header.text) + " ")
                  ])
                }),
                0
              )
            ])
          : _vm._e(),
        _setup.breakpoints.mobile
          ? _c(
              "tbody",
              _vm._l(_setup.tableItems, function(item) {
                return _c("tr", { key: item.id, staticClass: "mobile-row" }, [
                  _c("td", [
                    _c("div", { staticClass: "mobile" }, [
                      _c("div", { staticClass: "field" }, [
                        _c("span", { staticClass: "label" }, [_vm._v("Area")]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.area))
                        ])
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("span", { staticClass: "label" }, [_vm._v("Task")]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.task))
                        ])
                      ]),
                      _c("div", { staticClass: "field" }, [
                        _c("span", { staticClass: "label" }, [
                          _vm._v("Standard")
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(item.standard))
                        ])
                      ]),
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("span", { staticClass: "label" }, [
                            _vm._v("Is Standard")
                          ]),
                          _c("v-switch", {
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              color: "success",
                              loading: _setup.tableState.isLoading,
                              inset: ""
                            },
                            on: {
                              change: function($event) {
                                return _setup.update(item)
                              }
                            },
                            model: {
                              value: item.isStandard,
                              callback: function($$v) {
                                _vm.$set(item, "isStandard", $$v)
                              },
                              expression: "item.isStandard"
                            }
                          })
                        ],
                        1
                      ),
                      _setup.tableState.isLoading
                        ? _c("div", [_vm._v("Saving data...")])
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "field",
                          staticStyle: { padding: "10px 0px" }
                        },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Remarks",
                              loading: _setup.tableState.isLoading,
                              "hide-details": "",
                              dense: ""
                            },
                            on: {
                              change: function($event) {
                                return _setup.update(item)
                              }
                            },
                            model: {
                              value: item.remarks,
                              callback: function($$v) {
                                _vm.$set(item, "remarks", $$v)
                              },
                              expression: "item.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                ])
              }),
              0
            )
          : _c(
              "tbody",
              _vm._l(_setup.tableItems, function(item) {
                return _c("tr", { key: item.id }, [
                  _c("td", { style: { textTransform: "uppercase" } }, [
                    _vm._v(_vm._s(item.area))
                  ]),
                  _c("td", [_vm._v(_vm._s(item.task))]),
                  _c(
                    "td",
                    { staticClass: "standard-col" },
                    [
                      _c("span", [_vm._v(_vm._s(item.standard))]),
                      _c("v-checkbox", {
                        attrs: { "hide-details": "", dense: "" },
                        on: {
                          change: function($event) {
                            return _setup.update(item)
                          }
                        },
                        model: {
                          value: item.isStandard,
                          callback: function($$v) {
                            _vm.$set(item, "isStandard", $$v)
                          },
                          expression: "item.isStandard"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c("v-text-field", {
                        attrs: {
                          loading: _setup.tableState.isLoading,
                          outlined: "",
                          "hide-details": "",
                          dense: ""
                        },
                        on: {
                          change: function($event) {
                            return _setup.update(item)
                          }
                        },
                        model: {
                          value: item.remarks,
                          callback: function($$v) {
                            _vm.$set(item, "remarks", $$v)
                          },
                          expression: "item.remarks"
                        }
                      })
                    ],
                    1
                  )
                ])
              }),
              0
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }